export default {"src":"/_next/static/media/check.7e4f8ea6.svg","height":24,"width":24};